<header
  class="py-1 border-bottom d-flex"
  [class.bg-primary]="!isSettingsLoaded()"
  [class.settings-color]="isSettingsLoaded()"
>
  <div class="d-flex justify-content-start align-items-center ps-4">
    <div class="border-end pe-2">
      <a routerLink="/" class="d-flex align-items-center mb-0 mb-lg-0 link-dark text-decoration-none">
        <img src="../../../../../assets/andritz/logo.svg" alt="Brand Logo" width="84" height="16" />
      </a>
      <p class="mb-0 ps-1 pe-2 text-white fs-6">{{ title() }}</p>
    </div>
  </div>
  @if (isNotError()) {
    <ng-content select="[left-nav]"></ng-content>
    <div class="flex-grow-1 d-flex justify-content-center align-items-center">
      <ng-content select="[title]"></ng-content>
    </div>
    <div class="d-flex justify-content-end align-items-center gap-3 pe-3">
      <ng-content select="[right-nav]"></ng-content>
    </div>
    <div class="d-flex flex-nowrap align-items-center border-start px-2">
      <adf-expander />
      <adf-notifications />
      <adf-help />
    </div>
  } @else {
    <div class="flex-grow-1"></div>
  }
  <div class="d-flex justify-content-end align-items-center gap-3">
    <div class="border-start ps-3">
      <adf-user-menu [userDisplayName]="userName()" (logout)="onLogout()" />
    </div>
  </div>
</header>
